// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModulesList__container{font:var(--main-font)}`, "",{"version":3,"sources":["webpack://./client/components/ModulesList.css"],"names":[],"mappings":"AAAA,wBACE,qBACF","sourcesContent":[".container {\n  font: var(--main-font);\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `ModulesList__container`;
export default ___CSS_LOADER_EXPORT___;
